import { SearchResponseType } from '../../../types/types';
export var isResultEmployer = function (r) {
    return r.responseType === SearchResponseType.EMPLOYER;
};
export function getSearchTabs(getLocalizedString) {
    return [
        { label: getLocalizedString('POPULAR'), value: 'popular' },
        { label: getLocalizedString('EMPLOYER'), value: 'employers' },
        { label: getLocalizedString('PAYROLL_TITLE'), value: 'platforms' },
        { label: getLocalizedString('GIG'), value: 'gigs' },
    ];
}
export function filterTabs(allTabOptions, initialProviders) {
    return allTabOptions.filter(function (option) {
        if (!initialProviders || !initialProviders[option.value]) {
            return false;
        }
        return initialProviders[option.value].length !== 0;
    });
}
